var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonitorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.94,6H10.2a9.07,9.07,0,0,0-9.06,9.06V61.23a9.07,9.07,0,0,0,9.06,9.06H40.83L35.49,86.63H24.79A2.36,2.36,0,0,0,22.43,89v.14a2.36,2.36,0,0,0,2.36,2.35H74.46a2.36,2.36,0,0,0,2.36-2.35V89a2.36,2.36,0,0,0-2.36-2.35H63.4L57.68,70.29H88.94A9.06,9.06,0,0,0,98,61.23V15.06A9.06,9.06,0,0,0,88.94,6ZM43,86.63l3-11.49h7.13l3,11.49Zm50.38-25.4a4.42,4.42,0,0,1-4.42,4.42H10.2a4.42,4.42,0,0,1-4.42-4.42V15.06a4.42,4.42,0,0,1,4.42-4.42H88.94a4.42,4.42,0,0,1,4.42,4.42Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorIcon);
export default __webpack_public_path__ + "static/media/monitor-icon.0cfe7b45f9df9ff52f5058a64ed81e31.svg";
export { ForwardRef as ReactComponent };